<template>
	<v-container fluid :style="'padding: 76px 0px 12px ' + (drawer ? 200 : 0) + 'px;'">

		<v-row v-if="loading">
			<v-col cols="12">
				<v-skeleton-loader type="table-tbody" />
			</v-col>
		</v-row>
        
    <v-row v-if="!loading" style="padding-top:0; margin-top: -24px;">
			<v-col cols="12" class="pt-4 pl-6 pb-0 d-flex justify-space-between align-center">
				<h3>{{ formatFullDate(new Date()) }}</h3>
				<div class="d-flex" style="font-size:0.7em; cursor: pointer;" @click="refreshAll()">
					<span>{{updateTime}}</span>
					<v-icon class="primary--text" style="padding-left:4px; font-size:1.6em">
						mdi-refresh
					</v-icon>
				</div>
			</v-col>
      <v-col cols="6" v-for="(widget, index) in widgets" :key="widget.id">
        <WidgetWrapper :editMode="false" :enableLeft="index > 0" :enableRight="index < widgets.length - 1" 
          ref="widgetRefs" :config="widget" :context="context[index]" @edit-action="(action) => onEditAction(widget, index, action)" style="width. auto;" />
      </v-col>
			<v-col cols="12" v-if="!this.widgets || this.widgets.length === 0">
				<div class="transparent empty-state center-align">
					<div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
						<div class="text-center">
							<v-icon class="large material-icons" style="cursor: pointer;">mdi-widgets</v-icon>
							<h4 class="mt-4">{{ $t('dashboards.widget.empty') }}</h4>
						</div>
					</div>
				</div>
			</v-col>
    </v-row>
        
    <!--<SelectWidgetDialog :showDialog="showSelectWidgetDialog" :currentLicense="currentLicense" :widgets="allWidgets" v-on:select-widget="selectWidget"></SelectWidgetDialog>-->

  </v-container>
</template>

<script>
import api from '../../api/humanway';
import BaseModule from '../common/BaseModule';
import WidgetWrapper from '../common/WidgetWrapper.vue';

export default {
	components: {
		WidgetWrapper
	},
	name: 'HomeModule',
	mixins: [BaseModule],
	props: ['drawer'],
	data () {
		return {
			loading: false,
      updateTime: null,
			widgets: [],
			context: [
				{ sortBy: 'creation_date', sortDesc: true },
				{ sortBy: 'processed_date', sortDesc: true },
			],
		}
	},
	mounted() {
		this.refreshAll();
	},
	computed: {
		userFullname(item) {
			return `${item.userFirstname} ${item.userLastname}`;
		}
	},
	methods: {
		refreshAll() {
			this.loading = true;

			api.getWidgets(
				(data) => {
					this.loading = false;
					this.widgets = data.entities;

					this.updateTime = this.formatLongDateTime(new Date().getTime());
				},
				(error) => {
					this.loading = false;
					this.$log.error(error);
					this.$emit('show-alert', { text: error, color: 'error' });
				}
			);
		},
	},
}
</script>